import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { ServiceIdsForMember } from '@/types/seekerCC';
import { useSeekerCCState } from '../AppState';

function useIsLoadingScreenDesign() {
  const { czenServiceIdForMember } = useSeekerCCState();
  const isDayCare = czenServiceIdForMember === ServiceIdsForMember.dayCare;
  const loadingScreenDesignsFlag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_CC_LOADING_SCREENS
  );

  const isBackgroundCheckVariant = !isDayCare && loadingScreenDesignsFlag?.value === 2;
  const isTestimonialVariant = !isDayCare && loadingScreenDesignsFlag?.value === 3;
  const isProviderProfilesVariant = !isDayCare && loadingScreenDesignsFlag?.value === 4;
  const isRemoveRecapPageVariant = !isDayCare && loadingScreenDesignsFlag?.value === 5;

  return {
    isBackgroundCheckVariant,
    isTestimonialVariant,
    isProviderProfilesVariant,
    isRemoveRecapPageVariant,
  };
}

export default useIsLoadingScreenDesign;
